import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, forkJoin } from 'rxjs';
import { EnvService } from '../../core/env.service';
import { map } from 'rxjs/operators'

import { GlobalService } from '../../commonservices/global.service';

import { InvoiceAttachmentsDTO, InvoiceFullDetailsViewModel  } from '@models/index';

@Injectable()
export class DashboardService {
    constructor(
        private _httpClient: HttpClient,
        public _env: EnvService,
        private globalS: GlobalService
    ) {

    }

    postselectall(data: any): Observable<any> {
        var params = this.globalS.serialize(data);
        return this._httpClient.post<any>(this._env.apictgf +'dashboard/PostSelectAll', data, { headers: new HttpHeaders({'ngsw-bypass': 'true' , 'Content-Type': 'application/json', }), responseType: 'blob' as 'json', reportProgress:true } );
    }

    getDashboardInvoicesHistory(data: any): Observable<any> {
        var params = this.globalS.serialize(data);
        return this._httpClient.get<any[]>(this._env.apictgf +'dashboard/GetDashboardInvoicesHistory', { params: params});
    }

    getDashboardOpenInvoices(data: any): Observable<any> {
        var params = this.globalS.serialize(data);
        return this._httpClient.post<any[]>(this._env.apictgf +'dashboard/PostDashboardOpenInvoices', data);
    }

    getdashboardpagination(data: any): Observable<any> {
        return this._httpClient.post<any[]>(this._env.apictgf +'dashboard/PostDashboardPagination', data);
    }

    getDashboardInvoices(data: any): Observable<any> {
        var params = this.globalS.serialize(data);
        return this._httpClient.post<any[]>(this._env.apictgf +'dashboard/PostDashboardInvoices', data);
    }
      
    getCurrency(): Observable<any> {
        return this._httpClient.get<any[]>(this._env.apictgf +'dashboard/getcurrency');
    }

    searchDashboard(data: any, page: number, client: string, invoiceShipment: boolean): Observable<any> {
        // var params = this.globalS.serialize(data);
        return this._httpClient.get<any[]>(this._env.apictgf +`dashboard/GetSearchDashboard?input=${data}&page=${page}&client=${client}&invoiceShipment=${invoiceShipment}`);
    }

    getDashboard(data: any): Observable<any> {
        // var params = this.globalS.serialize(data);
        return this._httpClient.post<any[]>(this._env.apictgf +'dashboard/PostDashboard', data).pipe(map((res: any) => res));
    }

    getDashboardPagination(data: any): Observable<any> {
        var params = this.globalS.serialize(data);
        return this._httpClient.post<any[]>(this._env.apictgf +'dashboard/PostDashboardPagination', data);
    }

    getCurrencyAndDashboard(code: string, invHistoryFilter: string, userType: string,  userId: Number ): Observable<any> {
        let currency = this._httpClient.get<any[]>(this._env.apictgf +'dashboard/getcurrency');
        let dashboard = this._httpClient.get<any>(this._env.apictgf +'dashboard/GetDashboard?currency=' + code 
                        + '&&invHistoryFilter='+invHistoryFilter +'&&userType='+userType+'&&userId='+userId);
        return forkJoin([currency,dashboard]);
    }

    getInvoice(currency:String, browserRefresh:boolean): Observable<any> {
        return this._httpClient.get<any>(this._env.apiWebResolution +'WebResInvoice/GetWebResInvoice?toCurrency='+currency+'&isRefresh='+browserRefresh)
        .pipe(map((res: any) => res));
    }

    getInvoiceById(invoiceId:Number): Observable<any> {
        return this._httpClient.get<any>(this._env.apiWebResolution +'WebResInvoice/GetWebResInvoiceById?invoiceId='+invoiceId)
         .pipe(map((res: any) => res));
    }
    
    getShipmentInformation(shipmentId:Number): Observable<InvoiceFullDetailsViewModel> {
        return this._httpClient.get<InvoiceFullDetailsViewModel>(this._env.apiWebResolution +'WebResInvoice/GetShipmentInformationDetails?shipmentId='+shipmentId)
         .pipe(map((res: InvoiceFullDetailsViewModel) => res));
    }

    getWebResAttachmentOpenPDF(fileName: string,isa: string,invoiceId: number):Observable<Blob> {
        return this._httpClient.get(this._env.imageArchiveUri +'Document/GetWebResAttachmentOpenPDF?fle='+fileName+'&isa='+isa+'&invoiceId='+invoiceId,
        { headers: new HttpHeaders({'ngsw-bypass': 'true' , 'Content-Type': 'application/json', }), responseType: 'blob'},);
    }
    getFileAttachment(invoiceId: String):Observable<Array<any>>{
        return this._httpClient.get<Array<any>>(this._env.apiWebResolution +'WebResInvoice/GetWebResFileAttachment?invoiceId='+ invoiceId)
        .pipe(map((res: any) => res));
    }

    getWebResAttachment(fileName: string,isa: string,invoiceId: number):Observable<Blob> {
        return this._httpClient.get(this._env.imageArchiveUri +'Document/GetWebResAttachment?fle='+fileName+'&isa='+isa+'&invoiceId='+invoiceId,{ headers: new HttpHeaders({'ngsw-bypass': 'true' ,
            'Content-Type': 'application/json',
          }),
           responseType: 'blob'},);
    }

    getAllocation(invoiceId: Number){
        return this._httpClient.get<Array<any>>(this._env.apictgf +'dashboard/GetAllocation?invoiceId='+ invoiceId)
        .pipe(map((res: any) => res));
    }
    getCountriesList(): Observable<any>{
        return this._httpClient.get('https://restcountries.eu/rest/v2/all').pipe(map((res: Array<any>) =>res));
    }

    HasWebResAccess(invoiceId: Number): Observable<any>{      
    return this._httpClient.get<Array<any>>(this._env.apictgf +'dashboard/HasWebResAccess?invoiceId='+invoiceId)
    .pipe(map((res: any) => res));
    }

    getExportInvoices(data: any): Observable<any> {
        var params = this.globalS.serialize(data);
        return this._httpClient.post<any[]>(this._env.apictgf +'dashboard/GetDashboardExport', data);
    }
    
}